import React, { useState, useEffect, useCallback, useRef } from 'react';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import classNames from 'classnames';

import { dispensingModuleManager } from 'redux/action/modules';

import Popup from 'popup/Popup';
import { BiCheckCircle } from 'react-icons/bi';
import { MdCancel } from 'react-icons/md';

import { DispensingSimplePopupContainer, DispensingSimple, DispensingSimpleSelectMap, MapIconContainer } from './DispensingSimplePopup.css';
import map from 'static/images/map/map_png.png';
import loading from 'static/images/loading/loading.gif';

const DispensingSimplePopup = ({ children, dataReloadFunc }) => {
  const dispatch = useDispatch();
  const coverRef = useRef();
  const user = useSelector(store => store.loginManager.status);
  const [ popupOpen, setPopupOpen ] = useState(null);
  const [ modules, setModules ] = useState([]);
  const [ selectModule, setSelectModule ] = useState(null);
  const [ deleteModule, setDeleteModule ] = useState([]);

  // 조회된 장치 상태저장함수
  const modulesDataSet = (responseData) => {
    setModules((modules) => {
      const moduleIdxs = modules.map((data) => { return data.moduleIdx });
      const responseDataIdxs = responseData.map((data) => { return data.moduleIdx });

      const result = [
        ...modules.filter(x => responseDataIdxs.includes(x.moduleIdx) && !deleteModule.includes(x.moduleIdx)),
        ...responseData.filter(x => !moduleIdxs.includes(x.moduleIdx) && !deleteModule.includes(x.moduleIdx))
      ];

      return result;
    });
  }

  // 장치조회 함수
  const getModules = () => {
    axios.get('/api/module/getDataByAuth/not/dispensing', {params: { authIdx: user.authIdx }})
      .then(response => {
        modulesDataSet(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  // 장치조회 타이머
  useEffect(() => {
    let timer;

    if (popupOpen) {
      timer = window.setInterval(() => {
        getModules();
      }, Number(5000));
    }
    else {
      window.clearInterval(timer);
    }

    return () => {
      window.clearInterval(timer);
    };
  }, [popupOpen])

  useEffect(() => {
    if (modules.length > 0 && !selectModule) {
      setSelectModule(modules[0].moduleIdx);
    }
  }, [modules])

  // 불출 submit 함수
  const dispensingSubmit = () => {
    coverRef.current.style.display = 'block';
    
    axios.post('/api/dispensing/insert/simple', modules)
      .then(response => {
        if (response.data) {
          alert('불출완료');
          coverRef.current.style.display = 'none';
          dispatch(dispensingModuleManager(user.authIdx));
          dataReloadFunc();
          setPopupOpen(false);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  // 맵에서 새로운 위치를 클릭 시
  const selectNewArea = useCallback((e) => {
    const offsetX = e.nativeEvent.offsetX;
    const offsetY = e.nativeEvent.offsetY;

    setModules((modules) => {
      return modules.map((data) => {
        return {
          ...data,
          xaxis: (data.moduleIdx === selectModule) ? offsetX * (900 / 535) : data.xaxis,
          yaxis: (data.moduleIdx === selectModule) ? offsetY * (900 / 535) : data.yaxis
        }
      })
    });
  }, [selectModule])

  // 장치리스트에서 특정장치 수동제거
  const deleteSelectModule = useCallback((selectModuleIdx) => {
    setModules((modules) => {
      return modules.filter(x => x.moduleIdx !== selectModuleIdx);
    });

    setDeleteModule((deleteModule) => {
      deleteModule.push(selectModuleIdx);
      return deleteModule;
    })
  }, [selectModule])

  // 팝업창 close시에 상태 초기화
  const initialState = () => {
    setModules([]);
    setSelectModule(null);
    setDeleteModule([]);
  }

  return(
    <Popup
      trigger={
        children
      }
      modal
      open={popupOpen}
      onOpen={() => { setPopupOpen(true); }}
      onClose={() => { initialState(); setPopupOpen(false); }}
    >
      <DispensingSimplePopupContainer>
        <DispensingSimple>
          <div className="popup-cover" ref={coverRef}></div>
          <div className="modules-container">
            {
              modules.map((data) => {
                return (
                  <div className={classNames('module-box', { on: data.moduleIdx === selectModule })}>
                    <div onClick={() => { setSelectModule(data.moduleIdx) }}>
                      <div>{ data.modelNm }</div>
                      { data.xaxis && data.yaxis && <BiCheckCircle /> } 
                    </div>
                    <MdCancel onClick={() => { deleteSelectModule(data.moduleIdx) }} />
                  </div>
                )
              })
            }
          </div>
          <DispensingSimpleSelectMap>
            {
              modules.length > 0 ? 
                modules.map((data) => {
                  return (
                    data.xaxis && data.yaxis && 
                    <MapIconContainer xAxis={data.xaxis / (900 / 535)} yAxis={data.yaxis / (900 / 535)} moduleScn={data.moduleScn}>
                      <img src='' alt="icon" />
                      <div>
                        {data.modelNm}
                      </div>
                    </MapIconContainer>
                  )
                }) :
                <div className="loading-box">
                  <span>장치를 찾고 있습니다</span>
                  <img src={loading} alt="map" />
                </div>
            }
            { modules.length > 0 && <img src={map} alt="map" onClick={selectNewArea} /> }
          </DispensingSimpleSelectMap>
          {
            modules.length > 0 && 
              <div>
                <button className="btn btn-primary" onClick={() => { dispensingSubmit(); }}>등록</button>
              </div>
          }
        </DispensingSimple>
      </DispensingSimplePopupContainer>
    </Popup>
  );
}

export default DispensingSimplePopup;